import { MainEndpoints } from "@authory-packages/core";
import { API_URL, withUserSlug } from "./index";
import axios from "axios";

export const subscribe = async ({ email, userId }: { email: string; userId: string }) => {
    const { data } = await axios.post<{ activationRequired: boolean }>(`${API_URL}${withUserSlug(MainEndpoints.UserSubscribe, userId)}`, {
        email
    });

    return data;
};
